<div class="chart-with-custom-y-axis" [ngClass]="{'compact-header': compactHeader}">
  <ng-content></ng-content>
</div>
